<template>
    <v-container>
        <v-card class="mx-auto my-12 pa-6" max-width="1000">
            <v-card-title class="text-h5">Denuncias Realizadas</v-card-title>
            <v-form>
                <v-text-field label="Identificador" type="string" variant="outlined" justify="center"
                    v-model="form.unique_id" />
                <v-btn type="submit" color="primary" @click="submitForm">Buscar</v-btn>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'SearchFormPublic',
    data() {
        return {
            form: {
                unique_id: "",

            },
        };
    },
    methods: {
        async submitForm() {
            console.log(this.form);
            try {
                const uniqueId = this.form.unique_id;
                console.log("Identificador único:", uniqueId);
                this.$router.push({
                    name: 'CaseDetailPublic',
                    params: { uniqueId: uniqueId }
                });
            } catch (error) {
                console.error("Error al enviar el formulario:", error);
            }
        },
    },

};
</script>